module.exports = __webpack_public_path__ + "667e3ed1f78263138f6f2ccad74fdc0c.svg";